import React, { Component } from 'react'
import styled, { css } from 'styled-components'

import Grid from "./SVGGrid"
import { flex } from '../styles'

const Hero = styled.div`
  ${flex.vertical}
  min-height: ${props => props.minSize}rem;
  height: calc(100vh - ${props => props.bottomBuffer}rem);
  max-height: 60rem;
  background: radial-gradient(ellipse 80vw 40vw at 50% 50%, #000455 0%, black 100%);
  position: relative;
  overflow: hidden;
  ${ props => props.fadeIn && css`
    animation: fade-in 1s 0s ease-out both;
    ~ * {
      animation: fade-in 0.6s ${props => props.theme.animating ? '2.9s' : '0s'} ease-out both;
    }
  `}
`

export default class extends Component {
  state = {}
  componentDidMount() {
    this.setState({mounted: true})
  }
  render() {
    const { children, fadeIn = true, bottomBuffer = 12, minSize = 24 } = this.props
    const { mounted } = this.state
    return (
      <Hero fadeIn={fadeIn} bottomBuffer={bottomBuffer} minSize={minSize}>
        { mounted && <Grid fadeIn={fadeIn}/> }
        { children }
      </Hero>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Hero.js
 **/